<template>

  <div v-if="!editing" v-bind:style="{ color: priorityColor }">
    <div>
      <a-popover
          v-if="hasDescription"
          placement="topLeft"
          title="Omschrijving"
      >
        <template #content>
          <div>
            {{ task.description }}
          </div>
        </template>
        <task-description-icon :type="task.type"></task-description-icon>
        {{ task.content }}
      </a-popover>
      <span v-else-if="!hasDescription">
          <task-description-icon :type="task.type"></task-description-icon>
          {{ task.content }}
      </span>
      <pencil-icon class="edit-name" style="cursor: pointer;"
                   @click.stop="onEditNameClick"></pencil-icon>
      <task-description-attachments v-if="hasAttachments"></task-description-attachments>
    </div>
  </div>
  <div v-else-if="editing">
    <a-input-group>
      <a-input ref="taskNameInput" :defaultValue="task.content" style="width: 80%;"
              :disabled="updateNameLoading"
               v-on:click.stop
               v-on:keyup.enter="onSave" v-on:keyup.esc="onCancel"></a-input>
      <a-button :loading="updateNameLoading" v-on:click.stop="onSave">
        <content-save-icon></content-save-icon>
      </a-button>
    </a-input-group>
  </div>
</template>

<script>
import TaskDescriptionIcon from '../components/TaskDescriptionIcon.vue';
import TaskDescriptionAttachments from '../components/TaskDescriptionAttachments.vue';
import taskApi from '~/api/task';
export default {
  name: "TaskDescriptionCell.vue",
  props: {
    row: Object,
  },
  components: {
    TaskDescriptionAttachments,
    TaskDescriptionIcon,
  },
  computed: {
    priorityColor() {
      if (this.task.priority === 0) {
        return '#ff0000';
      } else if (this.task.priority === 1) {
        return '#ee7600';
      } else if (this.task.priority === 2) {
        return '#000000';
      } else if (this.task.priority === 3) {
        return '#757575';
      } else {
        return '#000000';
      }
    },
    hasDescription() {
      return this.task.description !== null && this.task.description.length > 0;
    },
    hasAttachments() {
      return typeof this.task.attachables !== "undefined" && this.task.attachables !== null && this.task.attachables.data.length > 0;
    },
    task() {
      return this.row;
    }
  },
  data() {
    return {
      editing: false,
      updateNameLoading: false,
    }
  },
  methods: {
    onEditNameClick(e) {
      this.editing = true;
    },
    onSave() {
      this.updateTaskName();
    },
    onCancel() {
      this.editing = false;
      this.$refs.taskNameInput.stateValue = this.task.name;
    },
    updateTaskName() {
      if (this.task.content === this.$refs.taskNameInput.stateValue) {
        this.editing = false;
        return;
      }

      this.task.content = this.$refs.taskNameInput.stateValue;
      this.updateNameLoading = true;

      taskApi.updateName(this.task).then((response) => {
        this.editing = false;
        this.updateNameLoading = false;
      }).catch((error) => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Kon de gewijzigde naam van de taak niet opslaan',
        });
      });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
